
import Component from "vue-class-component";
import Vue from "vue";
import { ResultError, SysAdminTemplatesClient, SysAdminTemplatesSortField, PrintTemplate, FileModel, EndorsementPrintTemplateModel } from "@/api-client";
import { BvTableCtxObject, BvTableFieldArray } from "bootstrap-vue";
import TableEmptySlot from "@/features/shared/components/tables/TableEmptySlot.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import { translateTrueFalse } from "@/features/shared/TrueFalseTranslator";
import { debounceFn } from "debounce-decorator-ts";
import Loader from "@/features/shared/components/Loader";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
import toasts from "@/components/Toasts";
import ServersidePagingSelector from "@/components/ServersidePagingSelector.vue";

@Component({
  components: {
      TableEmptySlot,
      HeadingWave,
      SectionPageHeading,
      ButtonWithConfirm,
      ServersidePagingSelector
  },
})
export default class EndorsementPrintTemplates extends Vue {
  models: EndorsementPrintTemplateModel[] = [];

  loader = new Loader(true);

  async created() {
      this.$watch(() => this.$route.query, () => {
          this.getTemplates();
      }, { deep: true, immediate: true });
  }

  getTemplates() {
      this.models = [];

      new SysAdminTemplatesClient()
          .setLoader(this.loader)
          .allEndorsementPrintTemplates()
          .then(queryResult => {
              this.models = queryResult;
          });
  }

  navigateToDetails(model: EndorsementPrintTemplateModel) {
      this.$router.push({
          name: "endorsement-print-template",
          params: { type: model.printTemplateToUpdate! },
      });
  }

  fields: BvTableFieldArray = [
      {
          key: "printTemplate.nameEst",
          label: this.$ls.Global_Label_Name,
          thClass: "w-75",
          sortable: false
      },
  ];
}
